import React from 'react';
interface ScaleQuestionProps {
  selectedValue: number | null;
  onChange: (value: number) => void;
  labels: {
    range: string;
    description: string;
  }[];
}
export function ScaleQuestion({
  selectedValue,
  onChange,
  labels
}: ScaleQuestionProps) {
  return <div className="space-y-6" data-id="element-112">
      <div className="grid grid-cols-5 sm:grid-cols-10 gap-2" data-id="element-113">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => <button key={num} type="button" onClick={() => onChange(num)} className={`aspect-square min-h-[44px] rounded-lg border-2 font-semibold text-lg transition-all ${selectedValue === num ? 'border-crown-red bg-crown-red text-white' : 'border-crown-border bg-crown-surface text-crown-body hover:border-crown-muted'}`} data-id="element-114">
            {num}
          </button>)}
      </div>
      <div className="space-y-2" data-id="element-115">
        {labels.map((label, index) => <div key={index} className="text-sm text-crown-body" data-id="element-116">
            <span className="font-medium text-crown-text" data-id="element-117">{label.range}:</span>{' '}
            {label.description}
          </div>)}
      </div>
    </div>;
}